import React from 'react';
import './Main.css';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import ProductosMain from '../../Components/Admin/ProductosMain/ProductosMain';
import UsuariosMain from '../../Components/Admin/UsuariosMain/UsuariosMain';
import CardsCantidad from '../../Components/Admin/CardsCantidad/CardsCantidad';
import InfoUserMain from '../../Components/Admin/InfoUserMain/InfoUserMain';
import useAuthUser from '../../Components/useAuthUser';

export default function Main() {
    const { isAdmin } = useAuthUser();

    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='containerMain'>
                    <CardsCantidad />

                    <div className='dashboardWidgetsGrid'>
                        <div className='widgetColLeft'>
                            <ProductosMain />
                            {isAdmin && <UsuariosMain />}
                        </div>
                        <div className='widgetColRight'>
                            <InfoUserMain />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
